import { render } from "./ps-limits-details.vue?vue&type=template&id=eb765af6&ts=true"
import script from "./ps-limits-details.ts?vue&type=script&lang=ts"
export * from "./ps-limits-details.ts?vue&type=script&lang=ts"

import "./ps-limits-details.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__